import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CurrentModuleConfig } from '@portal-core/current/models/current-module-config.model';
import { CurrentModuleConfigService } from '@portal-core/current/services/current-module-config.service';

/**
 * Provides the current-license/user module configuration. The standalone replacement for
 * `CurrentServicesModule.forRoot(config)` — call it in an application's bootstrap providers.
 * @param config The current module configuration (configurator service bindings).
 */
export function provideCurrentServices(config: CurrentModuleConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: CurrentModuleConfigService,
      useValue: config
    }
  ]);
}
